import { render } from "./DaftarPengecualian.vue?vue&type=template&id=1b1db0a3"
import script from "./DaftarPengecualian.vue?vue&type=script&lang=js"
export * from "./DaftarPengecualian.vue?vue&type=script&lang=js"

import "./DaftarPengecualian.vue?vue&type=style&index=0&id=1b1db0a3&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__